export const VIEW_MODES = ['week', 'month', 'quarter', 'year'];
export const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const COLOR_CLASS = (count, isFuture = false) => {
  const suffix = isFuture ? '-orange' : '';
  if (count >= 3) return `intensity-3${suffix}`;
  if (count === 2) return `intensity-2${suffix}`;
  if (count === 1) return `intensity-1${suffix}`;
  return 'intensity-0';
};

export const formatDateLong = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

